import { Box, Stack, Typography } from "@mui/material";
  import { useEffect, useState } from "react";

  import ScheduleDays from "./ScheduleDays";
  import ScheduleTimes from "./ScheduleTimes";
  import SchedulePrograms from "./SchedulePrograms";
  import CurrentTimeIndicator from "./CurrentTimeIndicator";

  export default function ChannelSchedule({ schedule, channelID }) {
      const [currentTime, setCurrentTime] = useState(new Date());

      // update current time
      useEffect(() => {
          const interval = window.setInterval(() => {
              const newTime = new Date();
              setCurrentTime((prevTime) => {
                  if (newTime.getMinutes() !== prevTime.getMinutes())
                      return newTime;
                  return prevTime;
              });
          }, 1000);
          return () => window.clearInterval(interval);
      }, [currentTime]);

      // Handle null, undefined, or empty schedule AFTER hooks
      if (!schedule || !Array.isArray(schedule) || schedule.length === 0) {
          return (
              <Box
                  sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                      padding: 4
                  }}
              >
                  <Typography variant="h6" color="error">
                      Schedule Not Available
                  </Typography>
                  <Typography variant="body1" textAlign="center">
                      The broadcast schedule is not available for this station.
                      Please register this station in Storyline and edit the UUID to see schedule data.
                  </Typography>
                  <Typography variant="body2" textAlign="center" color="text.secondary">
                      Click the "Information" button above to return to station details.
                  </Typography>
              </Box>
          );
      }

      const scheduleStartTime = schedule[0].start;
      const scheduleEndTime = schedule[schedule.length - 1].stop;
      const scheduleTotalTime = scheduleEndTime - scheduleStartTime;

      return (
          <Box
              id="ChannelScheduleScrollBox"
              sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  "@media (max-height: 895px)": {
                      height: "inherit",
                  },
              }}
          >
              <Stack
                  id="ChannelScheduleContainer"
                  direction="row"
                  height={`${(scheduleTotalTime / 1000 / 60 / 60) * 10}em`} // 10em per minute
                  sx={{
                      width: "100%",
                      marginTop: "1em",
                      marginBottom: "1em",
                      "@media (max-width: 750px)": {
                          marginTop: "1.5em",
                          marginBottom: "1.5em",
                      },
                  }}
              >
                  <ScheduleDays
                      scheduleStartTime={scheduleStartTime}
                      scheduleEndTime={scheduleEndTime}
                  />
                  <ScheduleTimes
                      scheduleStartTime={scheduleStartTime}
                      scheduleEndTime={scheduleEndTime}
                  />
                  <SchedulePrograms
                      schedule={schedule}
                      currentTime={currentTime}
                      scheduleTotalTime={scheduleTotalTime}
                  />
                  <CurrentTimeIndicator
                      currentTime={currentTime}
                      scheduleStartTime={scheduleStartTime}
                      scheduleEndTime={scheduleEndTime}
                  />
              </Stack>
          </Box>
      );
  }